import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import InputBox from '../../../../component/InputBox';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import Button from '../../../../component/Button';
import SelectBox from '../../../../component/SelectBox';
import CreateRolePermission from './RolePermission';
import SuccessModal from '../../../../modalComponents/SuccessModal';
import Exported from '../../../../service/endpoints';
import request from '../../../../service';
import { Toast } from '../../../../service/toast';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';
import { useDispatch, useSelector } from 'react-redux';
import { saveUserPermission } from '../../../../redux/reducers/authSlice';
import GetUserPermission from '../../../../component/GetUserPermission';

const permissionRole = [
    { title: 'Dashboard', all: false, view: true, edit: false, add: false, delete: false },
    { title: 'Manage Users', all: false, view: true, edit: false, add: false, delete: false },
    { title: 'Manage admins', all: false, view: true, edit: false, add: false, delete: false },
    { title: 'Product Catalog', all: false, view: true, edit: false, add: false, delete: false },
    { title: 'Resources', all: false, view: true, edit: false, add: false, delete: false },
    { title: 'Loyalty Program', all: false, view: true, edit: false, add: false, delete: false },
    { title: 'Retailer TOD', all: false, view: true, edit: false, add: false, delete: false },
    { title: 'Rewards', all: false, view: true, edit: false, add: false, delete: false },
    { title: 'Redeem Rewards', all: false, view: true, edit: false, add: false, delete: false },
    { title: 'Product Feedback', all: false, view: true, edit: false, add: false, delete: false },
    { title: 'Product Enquiry', all: false, view: true, edit: false, add: false, delete: false },
    { title: 'Contact Form', all: false, view: true, edit: false, add: false, delete: false },
    { title: 'Manage Content', all: false, view: true, edit: false, add: false, delete: false },
    { title: 'Notifications', all: false, view: true, edit: false, add: false, delete: false },
    { title: 'QR Code', all: false, view: true, edit: false, add: false, delete: false },
    { title: 'Reports', all: false, view: true, edit: false, add: false, delete: false },
]

const CreateAdmin = () => {
    const formMethods = useForm({
        mode: "onSubmit",
    });
    const {
        handleSubmit,
        formState: { errors },
        trigger,
        watch,
        setValue,
        register,
    } = formMethods;

    const [rolePermitted, setRolePermitted] = useState(permissionRole);
    const [showVerifyPopUp, setShowVerifyPopUp] = useState(false)
    const [isEdit, setIsEdit] = useState(null)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation();
    const userID = useSelector((state) => state.auth.userData?.id);
    const addPermission = GetUserPermission({ key: 'add', microAppPath: 'manageAdmins' });
    const editPermission = GetUserPermission({ key: 'edit', microAppPath: 'manageAdmins' });

    const passwordInput = watch('password');
    const confirmPasswordInput = watch('confirmPassword');
    const adminStatus = watch('status');

    const statusList = [
        { label: 'Active', value: 'active' },
        { label: 'Inactive', value: 'inactive' },
    ]

    useEffect(() => {
        if (isEdit) {
            if (!editPermission) {
                redirectBack()
            }
        } else {
            if (!addPermission) {
                redirectBack()
            }
        }
    }, [isEdit])

    useEffect(() => {
        let searchById = getUserId()
        if (searchById) {
            setIsEdit(searchById)
            getUserDetails(searchById)
        }
    }, [location])

    const getUserId = () => {
        let searchById = location?.search?.split("?id=")
        return searchById?.at(1)
    }

    const getUserDetails = async (id, updateState) => {
        let url = `${Exported.Endpoints.getAdminList}/${id}`

        await request({
            url: url,
        }).then(async (res) => {
            if (res?.data?.status) {
                let detailInfo = res?.data?.data
                if (updateState) {
                    dispatch(saveUserPermission(detailInfo?.permissions || permissionRole))
                } else {
                    setValue('email', detailInfo?.email);
                    setValue('name', detailInfo?.name);
                    setValue('status', detailInfo?.status ? 'active' : 'inactive');
                    setRolePermitted(detailInfo?.permissions || permissionRole)
                }
            }
        }).catch((err) => {
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    }

    useEffect(() => {
        if (passwordInput?.length > 5 && confirmPasswordInput?.length > 5) {
            trigger()
        }
    }, [passwordInput, confirmPasswordInput, adminStatus])

    const redirectBack = () => {
        navigate('/admin/manageAdmins')
    }
    const onSubmit = async (data) => {
        trigger();
        let url = isEdit ? `${Exported.Endpoints.getAdminList}/${isEdit}` : `${Exported.Endpoints.getAdminList}`
        let paramsObj = {
            name: data?.name,
            email: data?.email,
            status: data?.status === "active" ? true : false,
            permissions: rolePermitted
        }
        if (!isEdit) {
            paramsObj['password'] = data?.password
        }
        dispatch(saveLoadingState(true))
        let successResponse = false
        await request({
            url: url,
            method: isEdit ? Exported.APIMethods.PUT : Exported.APIMethods.POST,
            data: {
                ...paramsObj
            }
        }).then((res) => {
            if (res?.data?.status) {
                successResponse = true
            } else {
                successResponse = false
            }
        }).catch((err) => {
            successResponse = false
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        if (successResponse) {
            if (isEdit) {
                if (getUserId() == userID) {
                    getUserDetails(getUserId(), 'updateState')
                }
                Toast({
                    type: 'success',
                    message: 'Submitted Successfully!...'
                })
                handleVerifyClose()
            } else {
                setShowVerifyPopUp(true)
                Toast({
                    type: 'success',
                    message: 'Admin created successfully.'
                })
            }
        }
        dispatch(saveLoadingState(false))
    };

    const handleVerifyClose = () => {
        setShowVerifyPopUp(false)
        redirectBack()
    }


    return (
        <>
            <div className={`${classes.createAdminWrapper}`}>
                <div className={`layout-title flex items-center`}>
                    <div className='mr-2 flex items-center cursor-pointer' onClick={() => redirectBack()}>
                        <ArrowBackIosOutlinedIcon />
                    </div>
                    <div>{isEdit ? 'Edit admin' : 'Create new admin'}</div>
                </div>
                <div className='my-8'>
                    <div className={classes.createFormWrapper}>
                        <div className={classes.formHeader}>General Info</div>
                        <FormProvider {...formMethods}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className={`${classes.formGroup} mt-5`}>
                                    <div className={`${classes.formField}`}>
                                        <InputBox
                                            label={"Name"}
                                            className={`w-[100%]`}
                                            name={"name"}
                                            isEdit={isEdit ? true : false}
                                            placeholder={'Name'}
                                            {...register("name", {
                                                required: true,
                                            })}
                                            error={errors.name}
                                            messages={{
                                                required: "Name is required",
                                            }}
                                        />
                                    </div>
                                    <div className={`${classes.formField}`}>
                                        <InputBox
                                            label={"Email"}
                                            className={`w-[100%]`}
                                            name={"email"}
                                            type={"email"}
                                            isEdit={isEdit ? true : false}
                                            placeholder={'Email'}
                                            {...register("email", {
                                                required: true,
                                                pattern: {
                                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                    message: "Invalid email address",
                                                },
                                            })}
                                            error={errors.email}
                                            messages={{
                                                required: "Email is required",
                                                pattern: "Invalid email address",
                                            }}
                                        />
                                    </div>
                                    {!isEdit ?
                                        <div className={`${classes.formField}`}>
                                            <InputBox
                                                label={"Password"}
                                                className={`w-[100%]`}
                                                type={"password"}
                                                name={"password"}
                                                placeholder={'Password'}
                                                {...register("password", {
                                                    required: isEdit ? false : true,
                                                    minLength: {
                                                        value: 6,
                                                    },
                                                })}
                                                error={errors.password}
                                                messages={{
                                                    required: "Password is required",
                                                    minLength: "Minimum 6 characters required",
                                                }}
                                            />
                                        </div> : null}
                                    {!isEdit ?
                                        <div className={`${classes.formField}`}>
                                            <InputBox
                                                label={"Confirm Password"}
                                                className={`w-[100%]`}
                                                type={"password"}
                                                name={"confirmPassword"}
                                                placeholder={'Confirm Password'}
                                                {...register("confirmPassword", {
                                                    required: isEdit ? false : true,
                                                    minLength: {
                                                        value: 6,
                                                    },
                                                    validate: value => value === passwordInput || 'Passwords do not match'
                                                })}
                                                error={errors.confirmPassword}
                                                messages={{
                                                    required: "Password is required",
                                                    minLength: "Minimum 6 characters required",
                                                    validate: "Passwords do not match"
                                                }}
                                            />
                                        </div> : null}
                                    <div className={`${classes.formField}`}>
                                        <Controller
                                            name="status"
                                            control={formMethods?.control}
                                            defaultValue=""
                                            rules={{ required: true }}
                                            render={({ field }) => (
                                                <SelectBox
                                                    label="Status"
                                                    placeholder="Status"
                                                    list={statusList}
                                                    isEdit={isEdit ? true : false}
                                                    {...field}
                                                    error={errors.status}
                                                    messages={{
                                                        required: "Status is required",
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                                <div className={`mt-8 ${classes.createFormWrapper}`}>
                                    <div className={classes.formHeader}>Role Permissions </div>
                                    <div className={`mt-5`}>
                                        <CreateRolePermission rolePermitted={rolePermitted} setRolePermitted={setRolePermitted} />
                                    </div>
                                </div>
                                <div className={`flex justify-end`}>
                                    <Button text={"Cancel"} className={'mr-4 !w-[140px]'} secondary smallBtn onClick={() => redirectBack()} />
                                    <Button text={"Save"} className={'!w-[140px]'} smallBtn />
                                </div>
                            </form>
                        </FormProvider>
                    </div>
                </div>
            </div>

            {showVerifyPopUp ?
                <SuccessModal
                    isOpen={showVerifyPopUp}
                    closePopUp={handleVerifyClose}
                    successText={'Success!'}
                    modalText={'New admin successfully added to the system.'}
                />
                : null
            }
        </>
    )
}

export default CreateAdmin